import { useAuthContext } from '@/features/auth/context'
import { useTranslation } from '@/hooks/useTranslation'
import { Box, Button, Stack, Typography } from '@mui/material'
import LogoDashboard from '../LogoDashboard'
import classes from './styles.module.scss'

const NoHasInterface = () => {
  const { logout } = useAuthContext()
  const { t } = useTranslation()

  return (
    <Stack className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.boxContent}>
          <Box sx={{ scale: '3.2' }}>
            <LogoDashboard />
          </Box>
          <Typography className={classes.txtContent}>
            {t('errorsPagesNoInterfaceTitle')}
          </Typography>
          <Button
            variant="primary"
            className={classes.btnAdmin}
            onClick={logout}
          >
            {t('errorsPagesBackToLogin')}
          </Button>
        </Box>
      </Box>
    </Stack>
  )
}

export default NoHasInterface
